var _style, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicatorTrend10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 304.5 184.8",
    style: {
      enableBackground: "new 0 0 304.5 184.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C75BC;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:url(#SVGID_14_);}\n\t.st15{fill:url(#SVGID_15_);}\n\t.st16{fill:url(#SVGID_16_);}\n\t.st17{fill:#D1D3D4;}\n\t.st18{fill:#E6E7E8;}\n\t.st19{fill:#58595B;}\n\t.st20{fill:url(#SVGID_17_);}\n\t.st21{fill:url(#SVGID_18_);}\n\t.st22{fill:url(#SVGID_19_);}\n\t.st23{fill:url(#SVGID_20_);}\n\t.st24{fill:url(#SVGID_21_);}\n\t.st25{fill:url(#SVGID_22_);}\n\t.st26{fill:url(#SVGID_23_);}\n\t.st27{fill:url(#SVGID_24_);}\n\t.st28{fill:url(#SVGID_25_);}\n\t.st29{fill:url(#SVGID_26_);}\n\t.st30{fill:url(#SVGID_27_);}\n\t.st31{fill:url(#SVGID_28_);}\n\t.st32{fill:url(#SVGID_29_);}\n\t.st33{fill:url(#SVGID_30_);}\n\t.st34{fill:url(#SVGID_31_);}\n\t.st35{fill:url(#SVGID_32_);}\n\t.st36{fill:#00AEEF;}\n\t.st37{fill:#059ADB;}\n\t.st38{fill:#0989CA;}\n\t.st39{fill:#3B6C8D;}\n\t.st40{fill:#3B6484;}\n\t.st41{fill:#3E4D6B;}\n\t.st42{fill:#3D506F;}\n\t.st43{fill:#3E5575;}\n\t.st44{fill:#3C5D7D;}\n\t.st45{fill:#EA9F43;}\n\t.st46{fill:#E27032;}\n\t.st47{fill:#DD4629;}\n\t.st48{fill:#7C1315;}\n\t.st49{fill:#99161A;}\n\t.st50{fill:#B61A20;}\n\t.st51{fill:#D21F25;}\n\t.st52{fill:#DA2726;}\n\t.st53{fill:#FAFAFA;}\n\t.st54{fill:url(#SVGID_33_);}\n\t.st55{fill:url(#SVGID_34_);}\n\t.st56{fill:url(#SVGID_35_);}\n\t.st57{fill:url(#SVGID_36_);}\n\t.st58{fill:url(#SVGID_37_);}\n\t.st59{fill:url(#SVGID_38_);}\n\t.st60{fill:url(#SVGID_39_);}\n\t.st61{fill:url(#SVGID_40_);}\n\t.st62{fill:url(#SVGID_41_);}\n\t.st63{fill:url(#SVGID_42_);}\n\t.st64{fill:url(#SVGID_43_);}\n\t.st65{fill:url(#SVGID_44_);}\n\t.st66{fill:url(#SVGID_45_);}\n\t.st67{fill:url(#SVGID_46_);}\n\t.st68{fill:url(#SVGID_47_);}\n\t.st69{fill:url(#SVGID_48_);}\n\t.st70{fill:url(#SVGID_49_);}\n\t.st71{fill:url(#SVGID_50_);}\n\t.st72{fill:url(#SVGID_51_);}\n\t.st73{fill:url(#SVGID_52_);}\n\t.st74{fill:url(#SVGID_53_);}\n\t.st75{fill:url(#SVGID_54_);}\n\t.st76{fill:url(#SVGID_55_);}\n\t.st77{fill:url(#SVGID_56_);}\n\t.st78{fill:url(#SVGID_57_);}\n\t.st79{fill:url(#SVGID_58_);}\n\t.st80{fill:url(#SVGID_59_);}\n\t.st81{fill:url(#SVGID_60_);}\n\t.st82{fill:url(#SVGID_61_);}\n\t.st83{fill:url(#SVGID_62_);}\n\t.st84{fill:url(#SVGID_63_);}\n\t.st85{fill:url(#SVGID_64_);}\n\t.st86{fill:url(#SVGID_65_);}\n\t.st87{fill:url(#SVGID_66_);}\n\t.st88{fill:url(#SVGID_67_);}\n\t.st89{fill:url(#SVGID_68_);}\n\t.st90{fill:url(#SVGID_69_);}\n\t.st91{fill:url(#SVGID_70_);}\n\t.st92{fill:url(#SVGID_71_);}\n\t.st93{fill:url(#SVGID_72_);}\n\t.st94{fill:url(#SVGID_73_);}\n\t.st95{fill:url(#SVGID_74_);}\n\t.st96{fill:url(#SVGID_75_);}\n\t.st97{fill:url(#SVGID_76_);}\n\t.st98{fill:url(#SVGID_77_);}\n\t.st99{fill:url(#SVGID_78_);}\n\t.st100{fill:url(#SVGID_79_);}\n\t.st101{fill:url(#SVGID_80_);}\n\t.st102{fill:url(#SVGID_81_);}\n\t.st103{fill:url(#SVGID_82_);}\n\t.st104{fill:url(#SVGID_83_);}\n\t.st105{fill:url(#SVGID_84_);}\n\t.st106{fill:url(#SVGID_85_);}\n\t.st107{fill:url(#SVGID_86_);}\n\t.st108{fill:url(#SVGID_87_);}\n\t.st109{fill:url(#SVGID_88_);}\n\t.st110{fill:url(#SVGID_89_);}\n\t.st111{fill:url(#SVGID_90_);}\n\t.st112{fill:url(#SVGID_91_);}\n\t.st113{fill:url(#SVGID_92_);}\n\t.st114{fill:url(#SVGID_93_);}\n\t.st115{fill:url(#SVGID_94_);}\n\t.st116{fill:url(#SVGID_95_);}\n\t.st117{fill:url(#SVGID_96_);}\n\t.st118{fill:url(#SVGID_97_);}\n\t.st119{fill:url(#SVGID_98_);}\n\t.st120{fill:url(#SVGID_99_);}\n\t.st121{fill:url(#SVGID_100_);}\n\t.st122{fill:url(#SVGID_101_);}\n\t.st123{fill:url(#SVGID_102_);}\n\t.st124{fill:url(#SVGID_103_);}\n\t.st125{fill:url(#SVGID_104_);}\n\t.st126{fill:url(#SVGID_105_);}\n\t.st127{fill:url(#SVGID_106_);}\n\t.st128{fill:url(#SVGID_107_);}\n\t.st129{fill:url(#SVGID_108_);}\n\t.st130{fill:url(#SVGID_109_);}\n\t.st131{fill:url(#SVGID_110_);}\n\t.st132{fill:url(#SVGID_111_);}\n\t.st133{fill:url(#SVGID_112_);}\n\t.st134{fill:url(#SVGID_113_);}\n\t.st135{fill:url(#SVGID_114_);}\n\t.st136{fill:url(#SVGID_115_);}\n\t.st137{fill:url(#SVGID_116_);}\n\t.st138{fill:url(#SVGID_117_);}\n\t.st139{fill:url(#SVGID_118_);}\n\t.st140{fill:url(#SVGID_119_);}\n\t.st141{fill:url(#SVGID_120_);}\n\t.st142{fill:url(#SVGID_121_);}\n\t.st143{fill:url(#SVGID_122_);}\n\t.st144{fill:url(#SVGID_123_);}\n\t.st145{fill:url(#SVGID_124_);}\n\t.st146{fill:url(#SVGID_125_);}\n\t.st147{fill:url(#SVGID_126_);}\n\t.st148{fill:url(#SVGID_127_);}\n\t.st149{fill:url(#SVGID_128_);}\n\t.st150{fill:url(#SVGID_129_);}\n\t.st151{fill:url(#SVGID_130_);}\n\t.st152{fill:url(#SVGID_131_);}\n\t.st153{fill:url(#SVGID_132_);}\n\t.st154{fill:url(#SVGID_133_);}\n\t.st155{fill:url(#SVGID_134_);}\n\t.st156{fill:url(#SVGID_135_);}\n\t.st157{fill:url(#SVGID_136_);}\n\t.st158{fill:url(#SVGID_137_);}\n\t.st159{fill:url(#SVGID_138_);}\n\t.st160{fill:url(#SVGID_139_);}\n\t.st161{fill:url(#SVGID_140_);}\n\t.st162{fill:url(#SVGID_141_);}\n\t.st163{fill:url(#SVGID_142_);}\n\t.st164{fill:url(#SVGID_143_);}\n\t.st165{fill:url(#SVGID_144_);}\n\t.st166{fill:url(#SVGID_145_);}\n\t.st167{fill:url(#SVGID_146_);}\n\t.st168{fill:url(#SVGID_147_);}\n\t.st169{fill:url(#SVGID_148_);}\n\t.st170{fill:url(#SVGID_149_);}\n\t.st171{fill:url(#SVGID_150_);}\n\t.st172{fill:url(#SVGID_151_);}\n\t.st173{fill:url(#SVGID_152_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "v10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main_12_"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 92.1,
    className: "st0",
    width: 301,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5,
    y1: 479.2,
    x2: 292.5,
    y2: 479.2,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.5,174.8 15.3,178.1 31.3,158.9 31.3,152.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 459.05,
    x2: 292.499,
    y2: 459.05,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.3,152.3 31.3,158.9 49,137.9 49,131.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 438.45,
    x2: 292.499,
    y2: 438.45,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "49,131.2 49,137.9 66,117.6 66,111  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 417.75,
    x2: 292.499,
    y2: 417.75,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "66,111 66,117.6 83.7,96.5 83.7,89.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 397.6,
    x2: 292.499,
    y2: 397.6,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "83.7,89.9 83.7,96.5 99.7,77.4 99.7,70.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 378.15,
    x2: 292.499,
    y2: 378.15,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "99.7,70.7 99.7,77.4 116.3,57.5 116.3,50.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 357.45,
    x2: 292.499,
    y2: 357.45,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "116.3,50.9 116.3,57.5 134.3,36 134.3,29.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.499,
    y1: 335.85,
    x2: 292.499,
    y2: 335.85,
    gradientTransform: "matrix(1 0 0 1 0 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3978,
    style: {
      stopColor: "#1B4586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5152,
    style: {
      stopColor: "#1C3871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#18295A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8018,
    style: {
      stopColor: "#121D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#0E1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C123C"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "152.5,7.7 152.2,8.1 134.3,29.4 134.3,36 152.5,14.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "292.5,174.8 273.7,152.3 273.7,159 289.7,178.1  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "256,131.3 256,137.9 273.7,159 273.7,152.3  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "239,111 239,117.6 256,137.9 256,131.3  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "221.3,89.9 221.3,96.5 239,117.6 239,111  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "205.3,70.8 205.3,77.4 221.3,96.5 221.3,89.9  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "188.7,50.9 188.7,57.5 205.3,77.4 205.3,70.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -16854.5039,
    y1: 357.45,
    x2: -16574.5039,
    y2: 357.45,
    gradientTransform: "matrix(-1 0 0 1 -16562.002 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751114"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    style: {
      stopColor: "#DA1F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3065,
    style: {
      stopColor: "#DB3828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#DD4929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    style: {
      stopColor: "#E26F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4086,
    style: {
      stopColor: "#E68C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#EBA546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    style: {
      stopColor: "#EFBC50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5687,
    style: {
      stopColor: "#F3CE58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6338,
    style: {
      stopColor: "#F5DC5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7099,
    style: {
      stopColor: "#F7E564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    style: {
      stopColor: "#F9EC67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9EF68"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "170.7,29.4 170.7,36.1 188.7,57.5 188.7,50.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -16854.5039,
    y1: 335.9,
    x2: -16574.5039,
    y2: 335.9,
    gradientTransform: "matrix(-1 0 0 1 -16562.002 -314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751114"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    style: {
      stopColor: "#DA1F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3065,
    style: {
      stopColor: "#DB3828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#DD4929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    style: {
      stopColor: "#E26F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4086,
    style: {
      stopColor: "#E68C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#EBA546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    style: {
      stopColor: "#EFBC50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5687,
    style: {
      stopColor: "#F3CE58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6338,
    style: {
      stopColor: "#F5DC5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7099,
    style: {
      stopColor: "#F7E564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    style: {
      stopColor: "#F9EC67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9EF68"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "152.8,8.1 152.5,7.7 152.5,14.4 170.7,36.1 170.7,29.4  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 45.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 50.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 55.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 60.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 65.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 70.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 75.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 80.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 85.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 95.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 100.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 105.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 110.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 115.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 120.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 125.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 130.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 135.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 140.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 145.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 150.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 155.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 160.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 165.7,
    className: "st36",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 170.7,
    className: "st36",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st36",
    cx: 14,
    cy: 33.7,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 14,
    cy: 176.3,
    r: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 45.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 50.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 55.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 60.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 65.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 70.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 75.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 80.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 85.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 95.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 100.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 105.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 110.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 115.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 120.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 125.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 130.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 135.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 140.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 145.7,
    className: "st37",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 150.7,
    className: "st37",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st37",
    cx: 31.5,
    cy: 33.7,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 31.5,
    cy: 155.4,
    r: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 45.7,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 50.8,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 55.8,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 60.8,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 65.8,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 70.9,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 75.9,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 80.9,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 86,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 96,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 101,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 106.1,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 111.1,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 116.1,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 121.2,
    className: "st38",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 126.2,
    className: "st38",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st38",
    cx: 49.5,
    cy: 33.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 49.5,
    cy: 134.1,
    r: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 45.8,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 50.8,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 55.8,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 60.8,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 65.9,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 70.9,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 75.9,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 81,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 86,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 96,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 101.1,
    className: "st39",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 106.1,
    className: "st39",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 66.2,
    cy: 33.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 66.2,
    cy: 114.1,
    r: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 45.8,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 50.8,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 55.9,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 60.9,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 65.9,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 71,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 76,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 81,
    className: "st40",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 86,
    className: "st40",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 83.7,
    cy: 33.7,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 83.7,
    cy: 93.1,
    r: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 138.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 133.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 128.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 123.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 118.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 113.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 108.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 103.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 98.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 88.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 83.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 78.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 73.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 68.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 63.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 58.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 53.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 48.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 43.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 38.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 33.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 28.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 23.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 18.7,
    className: "st41",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 13.7,
    className: "st41",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 152.5,
    cy: 153.8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 152.5,
    cy: 11.1,
    r: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 139.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 134.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 129.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 124.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 119.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 114.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 109.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 104.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 99.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 89.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 84.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 79.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 74.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 69.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 64.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 59.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 54.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 49.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 44.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 39.2,
    className: "st42",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 34.2,
    className: "st42",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 134.5,
    cy: 154.2,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 134.5,
    cy: 32.5,
    r: 2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 139.4,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 134.4,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 129.4,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 124.4,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 119.3,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 114.3,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 109.3,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 104.2,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 99.2,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 89.2,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 84.1,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 79.1,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 74.1,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 69,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 64,
    className: "st43",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 59,
    className: "st43",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st43",
    cx: 116.5,
    cy: 154.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 116.5,
    cy: 54.1,
    r: 2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 139.4,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 134.4,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 129.4,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 124.4,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 119.3,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 114.3,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 109.3,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 104.2,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 99.2,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 89.2,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 84.1,
    className: "st44",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 79.1,
    className: "st44",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st44",
    cx: 99.5,
    cy: 154.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 99.5,
    cy: 74.1,
    r: 2
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 139.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 134.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 129.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 124.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 119.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 114.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 109.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 104.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 99.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 89.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 84.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 79.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 74.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 69.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 64.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 59.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 54.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 49.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 44.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 39.2,
    className: "st45",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.5,
    y: 34.2,
    className: "st45",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st45",
    cx: 170.5,
    cy: 154.2,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 170.5,
    cy: 32.5,
    r: 2
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 139.4,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 134.4,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 129.4,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 124.4,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 119.3,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 114.3,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 109.3,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 104.2,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 99.2,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 89.2,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 84.1,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 79.1,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 74.1,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 69,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 64,
    className: "st46",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 59,
    className: "st46",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st46",
    cx: 188.5,
    cy: 154.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 188.5,
    cy: 54.1,
    r: 2
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 139.4,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 134.4,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 129.4,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 124.4,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 119.3,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 114.3,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 109.3,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 104.2,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 99.2,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 89.2,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 84.1,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 79.1,
    className: "st17",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 205.5,
    cy: 154.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 205.5,
    cy: 74.1,
    r: 2
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 45.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 50.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 55.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 60.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 65.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 70.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 75.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 80.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 85.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 95.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 100.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 105.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 110.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 115.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 120.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 125.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 130.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 135.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 140.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 145.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 150.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 155.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 160.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 165.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.4,
    y: 170.6,
    className: "st17",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 290.4,
    cy: 33.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 290.4,
    cy: 176.2,
    r: 2
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 45.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 50.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 55.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 60.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 65.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 70.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 75.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 80.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 85.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 95.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 100.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 105.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 110.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 115.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 120.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 125.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 130.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 135.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 140.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 145.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 150.6,
    className: "st17",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 272.8,
    cy: 33.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 272.8,
    cy: 155.3,
    r: 2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 45.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 50.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 55.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 60.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 65.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 70.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 75.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 80.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 85.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 95.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 100.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 106,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 111,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 116,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 121.1,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.8,
    y: 126.1,
    className: "st17",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 254.8,
    cy: 33.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 254.8,
    cy: 134,
    r: 2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 45.6,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 50.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 55.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 60.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 65.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 70.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 75.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 80.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 85.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 95.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 101,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 106,
    className: "st17",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 238.1,
    cy: 33.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 238.1,
    cy: 114,
    r: 2
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 45.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 50.7,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 55.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 60.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 65.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 70.8,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 75.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 80.9,
    className: "st17",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 85.9,
    className: "st17",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 220.7,
    cy: 33.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 220.7,
    cy: 93,
    r: 2
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M31.1,38.7v-7.2l-2,1.2V31c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1H31.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M10.6,33.4c0-1.4,0.3-2.5,1-3.5s1.6-1.4,2.7-1.4c2.3,0,3.5,1.7,3.5,5.1c0,1.6-0.3,2.9-0.9,3.8 s-1.5,1.4-2.6,1.4c-1.2,0-2.1-0.4-2.7-1.3S10.6,35.3,10.6,33.4z M12.4,33.5c0,1.3,0.1,2.3,0.4,2.9s0.7,0.9,1.3,0.9 c0.7,0,1.1-0.3,1.4-0.9s0.4-1.6,0.4-3s-0.1-2.3-0.4-2.8s-0.7-0.8-1.3-0.8C13,30,12.4,31.2,12.4,33.5z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M46.3,38.8v-0.5l3.2-4.7c0.6-0.9,1-1.7,1-2.4c0-0.8-0.5-1.1-1.4-1.1c-0.7,0-1.3,0.4-1.7,1.1l-1.2-0.9 c0.2-0.5,0.6-0.9,1.1-1.2s1.1-0.5,1.7-0.5c1,0,1.8,0.2,2.4,0.7s0.9,1.1,0.9,1.9s-0.4,1.7-1.1,2.8l-2.1,3.1h3.8v1.6h-6.6V38.8z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M63.4,37.9l0.9-1.4c0.5,0.6,1.1,0.8,1.7,0.8c1.1,0,1.7-0.5,1.7-1.6c0-0.5-0.2-0.9-0.5-1.2S66.4,34,65.9,34 h-0.3v-1.5h0.3c1,0,1.5-0.4,1.5-1.3c0-0.9-0.5-1.3-1.4-1.3c-0.5,0-1,0.2-1.4,0.7l-0.8-1.2c0.2-0.3,0.5-0.5,1-0.7s0.9-0.3,1.4-0.3 c1,0,1.8,0.2,2.3,0.7s0.8,1.1,0.8,1.9c0,1-0.4,1.7-1.3,2.2c1.1,0.5,1.6,1.3,1.6,2.5c0,1-0.3,1.7-0.9,2.2s-1.5,0.8-2.6,0.8 C65,38.9,64.1,38.5,63.4,37.9z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M85.9,36.1v2.6h-1.7v-2.6h-4.6v-1l5.5-6.4h0.8v6h1v1.4H85.9z M84.2,31.7l-2.6,3h2.6V31.7z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M96.6,158.7l0.7-1.5c0.7,0.6,1.3,0.8,1.9,0.8c1.1,0,1.7-0.7,1.7-2.1c0-0.7-0.1-1.2-0.4-1.5s-0.7-0.5-1.3-0.5 c-0.6,0-1.1,0.3-1.6,0.8l-0.7-0.5v-5h5.4v1.5h-3.7v1.8c0.3-0.1,0.7-0.2,1.1-0.2c1,0,1.7,0.3,2.3,0.9s0.8,1.4,0.8,2.4 c0,2.5-1.2,3.8-3.6,3.8C98.2,159.6,97.3,159.3,96.6,158.7z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M117.5,149.1l0.9,1c-0.7,0.4-1.3,0.8-1.9,1.4c-0.6,0.6-0.9,1.2-1.1,1.7c0.5-0.2,0.9-0.3,1.2-0.3 c0.9,0,1.7,0.3,2.3,0.9c0.6,0.6,0.9,1.4,0.9,2.4s-0.3,1.8-0.9,2.4c-0.6,0.6-1.3,0.9-2.2,0.9c-2.3,0-3.5-1.5-3.5-4.4 c0-1.2,0.5-2.5,1.4-3.7C115.5,150.1,116.4,149.3,117.5,149.1z M115,156.1c0,1.2,0.5,1.8,1.6,1.8c0.4,0,0.8-0.2,1-0.5 s0.4-0.7,0.4-1.3s-0.1-1-0.4-1.3s-0.6-0.5-1-0.5C115.6,154.4,115,154.9,115,156.1z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M133.8,159.3h-1.9c0.7-2.3,2-5.1,3.8-8.4h-4.6v-1.6h6.9v0.8l-0.9,1.7c-0.3,0.6-0.6,1.2-0.9,1.9 s-0.6,1.4-1,2.1c-0.3,0.7-0.6,1.4-0.8,2C134.1,158.2,133.9,158.8,133.8,159.3z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M150.8,153.8c-0.4-0.2-0.7-0.6-0.9-1c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.8,0.3-1.4,0.8-1.8 c0.5-0.5,1.2-0.7,2.1-0.7s1.6,0.2,2.1,0.7s0.8,1.1,0.8,1.8c0,0.4-0.1,0.8-0.4,1.3s-0.6,0.8-0.9,1c0.4,0.2,0.8,0.6,1.2,1.1 c0.4,0.5,0.6,1,0.6,1.5c0,0.9-0.3,1.7-0.9,2.2s-1.4,0.8-2.4,0.8s-1.8-0.3-2.4-0.8s-0.8-1.3-0.8-2.2c0-0.5,0.1-1,0.4-1.5 C150,154.4,150.3,154.1,150.8,153.8z M152.3,154.5c-0.9,0.5-1.3,1.1-1.3,1.9c0,0.4,0.1,0.8,0.4,1.1s0.6,0.4,1.1,0.4 s0.8-0.1,1.1-0.4c0.3-0.2,0.4-0.6,0.4-1C154,155.8,153.4,155.2,152.3,154.5z M152.7,153.1c0.3-0.1,0.5-0.3,0.7-0.7 c0.2-0.3,0.3-0.6,0.3-0.9c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.8,0-1.1,0.3-1.1,1c0,0.3,0.1,0.6,0.4,0.9 C152,152.8,152.3,153,152.7,153.1z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M169.5,159.4l-0.9-1c1.4-0.8,2.4-1.8,2.9-3c-0.3,0.1-0.7,0.2-1.2,0.2c-0.9,0-1.7-0.3-2.3-0.9 c-0.6-0.6-0.9-1.4-0.9-2.4s0.3-1.8,0.9-2.4s1.3-0.9,2.2-0.9c2.3,0,3.5,1.5,3.5,4.4c0,1.2-0.5,2.5-1.4,3.7 C171.5,158.4,170.6,159.2,169.5,159.4z M169,152.3c0,0.6,0.1,1,0.4,1.3s0.6,0.5,1,0.5c1,0,1.5-0.6,1.5-1.7c0-1.2-0.5-1.9-1.6-1.9 c-0.4,0-0.8,0.2-1,0.5C169.1,151.3,169,151.8,169,152.3z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M184.3,159.3V152l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1L184.3,159.3L184.3,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M187.1,154c0-1.4,0.3-2.5,1-3.5c0.7-0.9,1.6-1.4,2.7-1.4c2.3,0,3.5,1.7,3.5,5.1c0,1.6-0.3,2.9-0.9,3.8 c-0.6,0.9-1.5,1.4-2.6,1.4c-1.2,0-2.1-0.4-2.7-1.3C187.4,157.2,187.1,155.8,187.1,154z M188.9,154.1c0,1.3,0.1,2.3,0.4,2.9 s0.7,0.9,1.3,0.9c0.7,0,1.1-0.3,1.4-0.9s0.4-1.6,0.4-3s-0.1-2.3-0.4-2.8s-0.7-0.8-1.3-0.8C189.5,150.5,188.9,151.7,188.9,154.1z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M202.4,159.3V152l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1L202.4,159.3L202.4,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M207.6,159.3V152l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1L207.6,159.3L207.6,159.3z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M216.1,38.6v-7.2l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1H216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M219.5,38.6v-0.5l3.2-4.7c0.6-0.9,1-1.7,1-2.4c0-0.8-0.5-1.1-1.4-1.1c-0.7,0-1.3,0.4-1.7,1.1l-1.2-0.9 c0.2-0.5,0.6-0.9,1.1-1.2c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.8,0.2,2.4,0.7s0.9,1.1,0.9,1.9s-0.4,1.7-1.1,2.8l-2.1,3.1h3.8v1.6h-6.6 V38.6z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M234,38.6v-7.2l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1H234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M237,37.7l0.9-1.4c0.5,0.6,1.1,0.8,1.7,0.8c1.1,0,1.7-0.5,1.7-1.6c0-0.5-0.2-0.9-0.5-1.2s-0.8-0.5-1.3-0.5 h-0.3v-1.5h0.3c1,0,1.5-0.4,1.5-1.3s-0.5-1.3-1.4-1.3c-0.5,0-1,0.2-1.4,0.7l-0.8-1.2c0.2-0.3,0.5-0.5,1-0.7s0.9-0.3,1.4-0.3 c1,0,1.8,0.2,2.3,0.7c0.6,0.5,0.8,1.1,0.8,1.9c0,1-0.4,1.7-1.3,2.2c1.1,0.5,1.6,1.3,1.6,2.5c0,1-0.3,1.7-0.9,2.2s-1.5,0.8-2.6,0.8 C238.6,38.7,237.7,38.4,237,37.7z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M250.1,38.6v-7.2l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1H250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M259.6,36v2.6h-1.7V36h-4.6v-1l5.5-6.4h0.8v6h1V36H259.6z M257.9,31.5l-2.6,3h2.6V31.5z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M268.7,38.5v-7.2l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1H268.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M272.2,37.7l0.7-1.5c0.7,0.6,1.3,0.8,1.9,0.8c1.1,0,1.7-0.7,1.7-2.1c0-0.7-0.1-1.2-0.4-1.5s-0.7-0.5-1.3-0.5 c-0.6,0-1.1,0.3-1.6,0.8l-0.7-0.5v-5h5.4V30h-3.7v1.8c0.3-0.1,0.7-0.2,1.1-0.2c1,0,1.7,0.3,2.3,0.9c0.5,0.6,0.8,1.4,0.8,2.4 c0,2.5-1.2,3.8-3.6,3.8C273.8,38.6,272.9,38.3,272.2,37.7z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M286.4,38.6v-7.2l-2,1.2v-1.7c1.3-0.6,2.3-1.4,3.1-2.4h0.7v10.1H286.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M294.2,28.4l0.9,1c-0.7,0.4-1.3,0.8-1.9,1.4s-0.9,1.2-1.1,1.7c0.5-0.2,0.9-0.3,1.2-0.3 c0.9,0,1.7,0.3,2.3,0.9c0.6,0.6,0.9,1.4,0.9,2.4s-0.3,1.8-0.9,2.4c-0.6,0.6-1.3,0.9-2.2,0.9c-2.3,0-3.5-1.5-3.5-4.4 c0-1.2,0.5-2.5,1.3-3.7C292.1,29.4,293.1,28.6,294.2,28.4z M291.7,35.4c0,1.2,0.5,1.8,1.6,1.8c0.4,0,0.8-0.2,1-0.5 s0.4-0.7,0.4-1.3s-0.1-1-0.4-1.3s-0.6-0.5-1-0.5C292.2,33.7,291.7,34.2,291.7,35.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorTrend10);
export default __webpack_public_path__ + "static/media/indicator-trend-10.6d145786da494e5591301149ca1582cd.svg";
export { ForwardRef as ReactComponent };